import React, { useState }  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
const Styles = styled.div`
  margin: 2rem var(--universal-pad) 0;
  isolation: isolate;
  .top {
      display: flex;
      margin: 0 0 1rem;
      justify-content: space-between;
      text-decoration: none;
      color: inherit;
      .title {
          font-size: 1.25rem;
          font-weight: 600;
      }
  }
  .container {
    padding-bottom: 2.5rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    .country {
      min-width: 130px;
      max-width: 170px;
      flex-grow: 1;
      width: calc(10% - 0.5rem);
      background-color: var(--n-grey-0);
      padding: 1.5rem 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      justify-content: center;
      border-radius: var(--border-radius-3);
      position: relative;
      text-decoration: none;
      color: inherit;
      box-shadow: 0px 23px 40px -13px #00000014;
      &::before {
          content: "";
          z-index: -1;
          position: absolute;
          inset: -1px;
          background: linear-gradient(180deg, #E5E5E5 0%, #E5E5E500 100%);
          border-radius: calc(var(--border-radius-3) + 1px);
      }
      .image {
        margin-top: -0.5rem;
        width: 100%;
        img {
          width: 100%;
          display: block;
          border-radius: var(--border-radius-2);

        }
      }
      .text {
        font-weight: 700;
        color: var(--n-grey-2);
      }
    }
    .expand {
      cursor: pointer;
      width: 100%;
      text-align: center;
      padding: 0.5rem;
      color: var(--prime-1);
      font-weight: 700;
    }
  }
  @media screen and (max-width: 850px) {
    /* margin: 2rem 0 0; */
  }
`
export default function Countries27 (props){
  const {data: dataRaw, list = [], lan} = props;
  const data = JSON.parse(dataRaw);
  const [expand, setExpand] = useState(false);
  const makeCountries = () => {
    let newList = [...list];
    if(!expand){
      newList.splice(14, newList.length - 13)
    }
    return newList.map((v, i) => {
      return (
        <Link to={"/" + lan.filename + "/tour/"+ v.Continent_Url + "/" + v.Country_Url} className='country' key={i}>
          {
            (v.Country_Image) ? (
              <div className='image'>
                <img src={v.Country_Image} alt={(lan.filename === "fa") ? v.Country_Name : v.Country_En_Name}/>
              </div>
            ) : ""
          }
          <div className='text'>
            {(lan.filename === "fa") ? v.Country_Name : v.Country_En_Name}
          </div>
        </Link>
      )
    })
  }
  if(!Array.isArray(list)){
    return;
  }
  return (
    <Styles>
      <div className='top'>
          <h2 className='title'>
              {data.title}
          </h2>
      </div>
      <div className='container'>
        {makeCountries()}
        <div className='expand' onClick={() => setExpand(!expand)}>
          {
            (expand) ? (
              (lan.filename === "fa") ? (
                "کمتر"
              ) : "See less"
            ) : (
              (lan.filename === "fa") ? (
                "بیشتر"
              ) : "See More"
            )
          }
        </div>
      </div>
    </Styles>
  )
}

